module.exports = __webpack_public_path__ + "img/IMG_9928_L_Black_MockedUp.88088f98.jpg";